import { render } from "./Tracking.vue?vue&type=template&id=04a87c84"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"
script.render = render

export default script